import Repository from '../axios'

const resource = "/admin/notifications";

export default {
  getUnreadNotifications() {
    return Repository.get(`${resource}/unread`)
  },
  getAllNotifications() {
    return Repository.get(`${resource}`)
  },
  getAllNotificationManageList() {
    return Repository.get(`/admin/notification/manages`)
  },
  updateNotificationManage(id,payload) {
    return Repository.put(`/admin/notification/manages/${id}`, payload)
  },
  notificationMarkAsRead(id) {
    return Repository.put(`${resource}/mark-as-read`, { id: id })
  },
  notificationMarkAsUnRead(id) {
    return Repository.put(`${resource}/mark-as-unread`, { id: id })
  },
  notificationMarkAllAsRead() {
    return Repository.put(`${resource}/mark-all-as-read`)
  }
};
